import { render, staticRenderFns } from "./ActivitiesForm.vue?vue&type=template&id=8a5930be&scoped=true&lang=pug"
import script from "./ActivitiesForm.vue?vue&type=script&lang=js"
export * from "./ActivitiesForm.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesForm.vue?vue&type=style&index=0&id=8a5930be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5930be",
  null
  
)

export default component.exports